import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState: any = {
  meetingList: [],
  schools: [],
  classes: [],
  classesBySchool: [],
  teachers: [],
  loading: false,
  loadingAction: 0,
  searchFilter: {
    option: null,
    value: ''
  },
  meetingListFilters: {
    class_id:null
  },
  schoolsPaginated: { results: [], count: 0 },
  classesBySchoolPaginated: { results: [], count: 0 },
}

const calendarSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setMeetingList(state, action: PayloadAction<any>) {
      state.meetingList = action.payload
    },
    setSchools(state, action: PayloadAction<any>) {
      state.schools = action.payload
    },
    setClasses(state, action: PayloadAction<any>) {
      state.classes = action.payload
    },
    setClassesBySchool(state, action: PayloadAction<any>) {
      state.classesBySchool = action.payload
    },
    setTeachers(state, action: PayloadAction<any>) {
      state.teachers = action.payload
    },
    setLoading(state, action: PayloadAction<any>) {
      state.loading = action.payload
    },
    setSearchFilter(state, action: PayloadAction<{ option: number | null, value: string }>) {
      state.searchFilter = action.payload
    },
    setMeetingListFilters(state, action){
      state.meetingListFilters=action.payload
    },
    setLoadingAction(state, action: PayloadAction<number>) { 
      state.loadingAction = action.payload
    },
    setSchoolsPaginated(state, action: PayloadAction<any>) {
      state.schoolsPaginated = action.payload
    },
    setClassesBySchoolPaginated(state, action: PayloadAction<any>) {
      state.classesBySchoolPaginated = action.payload
    },
}
})

export const {
  setMeetingList,
  setSchools,
  setClasses,
  setClassesBySchool,
  setTeachers,
  setLoading,
  setSearchFilter,
  setMeetingListFilters,
  setLoadingAction,
  setSchoolsPaginated,
  setClassesBySchoolPaginated,
} = calendarSlice.actions;

export default calendarSlice.reducer;